module.exports = __webpack_public_path__ + "img/building.160021d8.jpg";